import type {
  RepackShrinkageItem,
  StockTransformation,
} from "@artisancode/api-types";

export function filterRepackings(
  transformations: StockTransformation[],
  query: string,
  status: string,
): StockTransformation[] {
  const q = query.toLowerCase();
  return transformations.filter((t) => {
    if (status !== "all" && t.status !== status) return false;
    if (!q.trim()) return true;
    const inputLine = t.lines?.find((l) => l.direction === "input");
    return [t.code, inputLine?.itemName, t.note].some((v) =>
      (v ?? "").toLowerCase().includes(q),
    );
  });
}

/** Input and output may differ in unit (2 kotak → 2.000 mL), so each side keeps its own. */
export function summarizeRepacking(t: StockTransformation) {
  const inputLine = t.lines?.find((l) => l.direction === "input");
  const outputLine = t.lines?.find((l) => l.direction === "output");
  const expectedQty = outputLine?.expectedQty ?? outputLine?.qty ?? 0;
  const shrinkagePercent =
    expectedQty > 0 ? ((t.shrinkageQty / expectedQty) * 100).toFixed(1) : "0";

  return {
    inputLine,
    outputLine,
    inputUom: inputLine?.uomName || "pcs",
    outputUom: outputLine?.uomName || "pcs",
    expectedQty,
    shrinkagePercent,
    shrinkageValue: Math.round(t.shrinkageQty * (outputLine?.unitCost ?? 0)),
  };
}

export function filterShrinkageItems(
  items: RepackShrinkageItem[],
  query: string,
): RepackShrinkageItem[] {
  const q = query.toLowerCase().trim();
  if (!q) return items;
  return items.filter((item) =>
    [item.rawMaterialName, item.rawMaterialSku, item.uomName].some((v) =>
      (v ?? "").toLowerCase().includes(q),
    ),
  );
}

export function formatShrinkagePercentage(pct: number): string {
  return `${pct.toFixed(1)}%`;
}
